export default "__VITE_ASSET__DaEEvuH___"